import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { LibraryModel } from '../models'

export interface MainPart extends LibraryModel {
    key: string
    new?: boolean
    updatedBy?: string
}
const url = `/libraries/management/types/mainPart/entries`

@Injectable()
export class MainPartService {
    constructor(private http: HttpService) {}

    getAll(): Observable<MainPart[]> {
        return this.http.get<MainPart[]>(url)
    }

    remove(data: MainPart[]): Observable<void> {
        return this.http.delete(url + '/', { data })
    }

    create(data: MainPart[]): Observable<MainPart[]> {
        return this.http.post<MainPart[]>(url, { data })
    }
    update(data: MainPart[]): Observable<MainPart[]> {
        return this.http.put<MainPart[]>(url, { data })
    }
}
